define('core/extensions/helpers/debug',[],function () {
    'use strict';

    // Debug helper for development only
    return function () {
        debugger;  // eslint-disable-line no-debugger
    };
});

